import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: ['customerOperateStatus', 'rowItem'],
  emits: ['open'],
  setup(__props, { emit }) {

const props = __props



const observeTarget = ref()
const timer = ref()
const nowTime = ref(new Date().getTime())

const btnDisabled = (rowItem:any) => {
  return false
  // if (props.customerOperateStatus !== 1) {
  //   return false
  // }
  // if (rowItem.type !== 8) {
  //   return false
  // }
  // return (new Date(rowItem.createTime).getTime() + 86400000 * 3) < nowTime.value
}

const visibleCallback = (changes: any) => {
  for (const change of changes) {
    if (change.intersectionRatio > 0) {
      if (new Date().getTime() > new Date(props.rowItem.createTime).getTime() + 86400000 * 3) {
        return
      }
      timer.value = setInterval(() => {
        nowTime.value = new Date().getTime()
      }, 1000)
      return
    }
    clearInterval(timer.value)
    timer.value = null
  }
}
const visibleObserve = new IntersectionObserver(visibleCallback, {})

onMounted(async () => {
  // observeTarget?.value && visibleObserve.observe(observeTarget.value)
})

onBeforeUnmount(() => {
  // observeTarget?.value && visibleObserve.unobserve(observeTarget.value)
})

const openProblemVisible = (rowItem:any) => {
  emit('open', rowItem)
}

return (_ctx: any,_cache: any) => {
  const _component_table_button = _resolveComponent("table-button")!

  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['observeTarget'] = _value
      observeTarget.value = _value
    }
  }, [
    _createVNode(_component_table_button, {
      title: __props.customerOperateStatus === 1?_unref(t)('问题处理'):_unref(t)('查看处理详情'),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openProblemVisible(__props.rowItem)), ["stop"])),
      disabled: btnDisabled(__props.rowItem)
    }, null, 8, ["title", "disabled"])
  ], 512))
}
}

})